// permission.service.ts
import { Injectable, inject } from '@angular/core';
import { AuthService } from '../../../core/services/conf/auth.service';

export enum Roles {
    ROOT = 'ROOT',
    ADMIN = 'ADMIN',
    RRHH = 'RRHH',
    ASISTENTE_RRHH = 'ASISTENTERRHH',
    CONTADOR = 'CONTADOR',
    ASISTENTE_CONTADOR = 'ASISTENTECONTADOR',
    CLIENTE = 'CLIENTE',
    ECOMMERCE = 'ECOMMERCE',
    ASISTENTE_ECOMMERCE = 'ASISTENTEECOMMERCE'
}

// Define grupos de roles para facilitar la asignación
export const RoleGroups = {
    FULL_ACCESS: [Roles.ROOT, Roles.ADMIN],
    ADMIN: [Roles.ROOT, Roles.ADMIN, Roles.CONTADOR, Roles.RRHH, Roles.ECOMMERCE],
    BASIC: [Roles.ROOT, Roles.ADMIN, Roles.RRHH, Roles.ASISTENTE_RRHH, Roles.CONTADOR, Roles.ASISTENTE_CONTADOR, Roles.ECOMMERCE, Roles.ASISTENTE_ECOMMERCE],
    RRHH_ADM: [Roles.ROOT, Roles.ADMIN, Roles.RRHH],
    RRHH_TEAM: [Roles.ROOT, Roles.ADMIN, Roles.RRHH, Roles.ASISTENTE_RRHH],
    CONTABILIDAD_ADM: [Roles.ROOT, Roles.ADMIN, Roles.CONTADOR],
    CONTABILIDAD_TEAM: [Roles.ROOT, Roles.ADMIN, Roles.RRHH, Roles.CONTADOR, Roles.ASISTENTE_CONTADOR],
    RRHH_CONTABILIDAD: [Roles.ROOT, Roles.ADMIN, Roles.RRHH, Roles.ASISTENTE_RRHH, Roles.CONTADOR, Roles.ASISTENTE_CONTADOR],
    ECOMMERCE_BASIC: [Roles.ROOT, Roles.ADMIN, Roles.RRHH, Roles.ASISTENTE_RRHH, Roles.CONTADOR, Roles.ASISTENTE_CONTADOR, Roles.ECOMMERCE, Roles.ASISTENTE_ECOMMERCE],
    ECOMMERCE: [Roles.ROOT, Roles.ADMIN, Roles.CONTADOR, Roles.ECOMMERCE, Roles.ASISTENTE_ECOMMERCE],
    ECOMMERCE_ADMIN: [Roles.ROOT, Roles.ADMIN, Roles.CONTADOR, Roles.ECOMMERCE]
};

@Injectable({
    providedIn: 'root'
})
export class PermissionService {
    private authService = inject(AuthService);

    hasRole(allowedRoles: Roles[] | string[]): boolean {
        const userRole = this.authService.getUserRole();
        return allowedRoles.includes(userRole as Roles);
    }

    hasAnyRole(...roles: Roles[]): boolean {
        return this.hasRole(roles);
    }

    isFullAccess(): boolean {
        return this.hasRole(RoleGroups.FULL_ACCESS);
    }

    isRRHHTeam(): boolean {
        return this.hasRole(RoleGroups.RRHH_TEAM);
    }

    isContabilidadTeam(): boolean {
        return this.hasRole(RoleGroups.CONTABILIDAD_TEAM);
    }
}
